import React from "react";
import { useSearchParams } from "react-router-dom";

import scaLogo from "../../assets/logos/scaLogo.svg";
import learnLogo from "../../assets/logos/learnLogo.svg";
import { LEARN_VERTICAL_ID } from "constants/config";

import styles from "./Header.module.scss";

const Header = () => {
  const [searchParams] = useSearchParams();
  const verticalId = searchParams.get("verticalId");
  const isLearn = Number(verticalId) === LEARN_VERTICAL_ID;

  const logoSrc = isLearn ? learnLogo : scaLogo;
  const logoAlt = isLearn ? "Learn logo" : "SCA logo";
  const headerClassName = isLearn
    ? `${styles.headerContainer} ${styles.learnHeader}`
    : styles.headerContainer;

  return (
    <div className={headerClassName}>
      <div className={styles.headerLeftContainer}>
        <img className={styles.logo} src={logoSrc} alt={logoAlt} />
      </div>
    </div>
  );
};

export default Header;